module.exports = __FOREMAN_VENDOR__UUID_V_1__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__UUID_V_1__"
// module id = uuid/v1
// module chunks = 0